import { Wardrobe } from '@/Engine/Wardrobe/Wardrobe';
import { V3dTools } from '@/v3d/common';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { WardrobeObject } from '@/Engine/Wardrobe/WardrobeObject';
import { Group, Ray, Vector3 } from 'three';
import { detachShelfDistance, leftArrowName, lineModelName, rackHoles } from '@/Constants/common';
import { shelvesBracketHeight } from '@/Constants/shelves';
import { $ } from '@/Engine/state';
import { shelfDocking } from '@/Engine/eventHandlers/lib/shelfDocking';
import { detachShelf } from '@/Engine/eventHandlers/lib/attachShelf';
import { Shelf, moduleItem } from '@/Interfaces/common';
import { getRandomItem } from '@/lib/math';
import { markCollisions } from '@/Engine/eventHandlers/lib/markCollisions';
import { PerforatedPanel } from '@/Engine/Wardrobe/PerforatedPanel';
import { TextMesh } from '@/Engine/Ruler/TextMesh';


export interface iProps extends moduleItem {
    parent: Wardrobe;
    place: number;
    humanName: string;
    v3dTools: V3dTools;
    rackModule: RackModule;
}

export class ShelfAndPanel extends WardrobeObject {
    _place = 0;
    parent: Wardrobe;
    v3dTools: V3dTools;
    humanName: string;
    rackModule?: RackModule;
    _position = new Vector3();
    rulerGroup: Group = new Group();

    constructor(props: iProps) {
        super({ ...props, raycastBox: true });
        this.parent = props.parent;
        this.color = props.color;
        this.v3dTools = props.v3dTools;
        this.place = props.place;
        this.humanName = props.humanName;
        this.model.add(this.rulerGroup);
    }

    get place() {
        return this._place;
    }

    set place(place) {
        this._place = place;
        this.position = this.position.clone();
    }

    get placeShift() {
        return this._place*rackHoles;
    }

    get position() {
        return this._position;
    }



    set modelPosition(pos: Vector3) {
        const modelPosition = new Vector3(
            pos.x,
            pos.y - this.placeShift,
            pos.z + 0.027,
        );
        // this.model.position.copy(modelPosition);
        //Проверять, что такая стойка уже существует и это её не первая позиция
        let heightForRack;
        if (this.type === 'shelf') heightForRack = shelvesBracketHeight;
        else heightForRack = this.height;
        this.updateRackHeight();

        if(this.rackModule &&
            !this.rackModule.checkRackHeight(this.place, heightForRack))
            this._place=this.rackModule.getMaxPlace(heightForRack);

        this.model.position.copy(modelPosition);
    }

    get modelPosition() {
        return this.model.position;
    }

    get leftPoint() {
        return this.position.clone().add(new Vector3(-this.width,0,0));
    }

    get rightPoint() {
        return this.position.clone().add(new Vector3(this.width,0,0));
    }

    checkPanelWithRackCollision() {

        const collision = $.checkCollisionWithRack(this, this.side, [
            this.rackModule?.rackLeft?.uuid,
            this.rackModule?.rackRight?.uuid,
        ]);

        if (collision) {
            // Если ставим посередине
            if (this.position.distanceTo(collision.parent.position) < 0.05) return null;
            else
                return collision;
        } else return null;
    }

    changePlace(pos: Vector3, modulePosition: Vector3)  {
        const newPlace = Math.round((this.position.y - pos.y)/rackHoles);
        if (newPlace !== this._place) {
            const oldPlace = this._place;
            this._place = newPlace < 0?0:newPlace;

            this.modelPosition = modulePosition;
            this.computeObb();
            // if (this.type === 'panel' && this.checkPanelWithRackCollision()) {
            //     this.place = oldPlace;
            // }
            const collision = $.checkShelfCollision(this, this.side);
            if (collision) {
                const collisionShelf = collision as Shelf;
                if (!shelfDocking(this, collisionShelf)) {
                    this.place = oldPlace;
                }

            }
        }
    }

    getModulePosition(pos: Vector3) {
        return  new Vector3(
            pos.x,
            this._position.y,
            pos.z,
        );
    }

    set shelfPosition(pos: Vector3) {
        const modulePosition = this.getModulePosition(pos);
        const oldPosition = this.position.clone();
        const deltaX = Math.abs(oldPosition.x - pos.x);

        // Если на рейке один модуль, то перемещаем весь модуль
        if (this.rackModule &&
            this.rackModule.railGroup &&
            this.rackModule.railGroup.racks.length < 2 &&
            this.rackModule.shelves.length < 2
        ) {
            if ($.bigDistanceFlag) {
                const newModulePos = new Vector3(
                    pos.x,
                    pos.y + this.placeShift,
                    pos.z,
                );
                this.position = newModulePos;
            } else {
                const newPos = new Vector3(
                    oldPosition.x,
                    modulePosition.y,
                    modulePosition.z,
                );
                this.changePlace(pos, newPos);
                this.position = newPos;
                // if (this.position.distanceTo(oldPosition) > 0.1)
                //     this.checkRackCollisions(oldPosition);
                // else
                //     this.checkRackCollisions();
                // if (this.type === 'panel' && this.checkPanelWithRackCollision()) {
                //     this.position = oldPosition;
                // }
            }

            // this.position = modulePosition;
            // markCollisions();
            return;
        }

        // Если в модуле одна полка, то перемещаем весь модуль
        if (this.rackModule &&
            this.rackModule.shelves.length <  2 &&
            this.rackModule.railGroup &&
            this.rackModule.railGroup.racks.length > 1
        ) {
            const newPos = new Vector3(
                oldPosition.x,
                modulePosition.y,
                modulePosition.z,
            );
            this.position = newPos;
            this.computeObb();
            markCollisions();
            this.changePlace(pos, newPos);
            this.position = modulePosition;
            return;
        }

        // Если в модуле несколько полок, то перемещаем полку по модули,
        // а при большом горизонтальном перемещении отстыковываем полку
        if (this.rackModule &&
            this.rackModule.shelves.length >  1
        ) {
            const newPos = new Vector3(
                oldPosition.x,
                modulePosition.y,
                modulePosition.z,
            );
            this.position = newPos;
            this.computeObb();
            this.changePlace(pos, newPos);
            if (Math.abs(pos.x - this._position.x) > detachShelfDistance) {
                detachShelf(this as unknown as Shelf);
                this.position = modulePosition;
                // this.checkRackCollisions();
            } else {
                this.position = this._position;
                // this.checkRackCollisions();
                this.rackModule.checkRackCollision();
            }

            // if (this.type === 'panel' && this.checkPanelWithRackCollision()) {
            //     this.position = oldPosition;
            // }
            // markCollisions();
            return;
        }

        // Если полка без обвеса
        // this.position = pos;

    }

    set position(pos: Vector3) {
        // не трогать стойку если в ней больше 1 полки
        if (this.rackModule && (this.rackModule.shelves.length > 1 ||
            this.rackModule.stacked)
        ) {
            const shelfPosition = new Vector3(
                this.rackModule.position.x,
                pos.y,
                this.rackModule.position.z,
            );
            this._position.copy(shelfPosition);
            this.modelPosition = shelfPosition;
            this.updateRackHeight();
            this.computeObb();
            return;
        }

        this._position.copy(pos);
        this.modelPosition = pos;
        this._updateBox();

        // Проверка на временный нужна, чтобы исключить добавление на сцену удаленного модуля
        if (this.rackModule &&
            this.rackModule.uuid !== 'temp') {
            this.rackModule.position = pos;
            this.updateRackHeight();
            $.room.addToWall(this.rackModule.model, this.side);

            // if (this.railGroup &&
            //     this.railGroup.uuid !== 'temp') {
            //     this.railGroup.position = pos;
            //     $.room.addToWall(this.railGroup.model, this.side);
            // }
        }

        this.computeObb();
    }

    updateRackHeight() {
        if (!this.rackModule) return;
        this.rackModule.updateRacks();
    }

    getLowerShelfObject(ray: Ray) {
        return super.getLowerObject(ray, this.parent.shelves);
    }

    getLowerShelfDistance(ray: Ray): number {
        return super.getLowerDistance(ray, this.parent.shelves);
    }

    getDecor(decors: typeof $.decorModelsBySurface, decorName: string, heightLimit?: number) {
        const decorForSurface = decors.get(decorName);
        if (!decorForSurface) return null;

        const filteredDecor = decorForSurface
            .filter((decor)=>
                decor.raw.rooms.some((room)=>room.code === $.selectedRoomType))
            .filter((decor) => {
                if (!decor.raw.width) return true;
                return decor.raw.width <= this.width;
            })
            .filter((decor)=>{
                if (!decor.raw.height || decorName === 'barbell') return true;
                return !heightLimit || decor.raw.height <= heightLimit;
            })
            .filter((decor)=>{
                if (!decor.raw.depth || this.type === 'panel') return true;
                if (decorName === 'barbell') return true;
                return decor.raw.depth <= this.depth;
            });
        const decor = getRandomItem(this.uuid, filteredDecor);

        if (!decor || !decor.model) return null;
        return decor;
    }

    addRuler = () => {
        this.rulerGroup.clear();
        if (!$.isRuler) return;
        this.rulerGroup.position.set(-this.width/2 + 0.06,0.032, this.depth);
        const text = ''+ Math.ceil((this.position.y - this.placeShift) * 1000);//+'мм';
        // const text = 'Test';
        const textMesh = new TextMesh(text);
        const lineCenter:Vector3 = new Vector3();
        this.rulerGroup.add(textMesh.model);
        const modelLineProto = $.v3dTools.getObjectByName(lineModelName);
        if (!modelLineProto) {
            console.warn('No model find: ', lineModelName);
            return;
        }

        const modelArrowProto = $.v3dTools.getObjectByName(leftArrowName);
        if (!modelArrowProto) {
            console.warn('No model find: ', lineModelName);
            return;
        }

        const arrowModel = modelArrowProto.clone();
        arrowModel.material.depthWrite = false;
        arrowModel.material.depthTest = false;
        arrowModel.renderOrder = 70;
        arrowModel.rotation.x = Math.PI/2;
        arrowModel.position.set(-0.045, -0.043, 0);
        arrowModel.scale.set(1, 1, 1);
        this.rulerGroup.add(arrowModel);

        const lineModelHeight = modelLineProto.clone();
        lineModelHeight.material.depthWrite = false;
        lineModelHeight.material.depthTest = false;
        lineModelHeight.renderOrder = 70;
        lineModelHeight.rotation.x = Math.PI/2;
        lineModelHeight.rotation.y = Math.PI/2;
        lineModelHeight.position.set(0, -0.032, 0);
        lineModelHeight.scale.set(1, 1, 6);
        this.rulerGroup.add(lineModelHeight);
    };

}
